"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const { rem } = ui_common_components_1.utils;
const StyledButtonContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  width: fit-content;
  ${({ theme, variant }) => (0, styled_components_1.css) `
    height: ${rem(theme.Components.PopupMenu.Button.Size)};
    max-width: ${variant === 'tooltip'
    ? rem(theme.Components.PopupMenu.Button.Size)
    : 'auto'};
  `}

  & button {
    ${({ variant, theme }) => (0, styled_components_1.css) `
      height: ${rem(theme.Components.PopupMenu.Button.Size)};
      max-width: ${variant === 'tooltip'
    ? rem(theme.Components.PopupMenu.Button.Size)
    : 'auto'};

      &:hover {
        background-color: ${theme.Color.Neutrals.Light};
      }
      outline: none;
    `}
  }
`;
function Button({ title, icon, variant, onClick, disabled = false, children, }) {
    return ((0, jsx_runtime_1.jsx)(StyledButtonContainer, { variant: variant !== null && variant !== void 0 ? variant : 'tooltip', children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { title: variant === 'tooltip' ? title : undefined, variant: "ghost", onClick: onClick, icon: icon, disabled: disabled, label: variant === 'title' ? title : undefined, children: children }) }));
}
exports.Button = Button;
//# sourceMappingURL=Button.js.map